import { dataTransferWrap } from '../dataTransferService'

import dtConfig from '@/config/data-transfer'
import { ModulesMap } from '@/config/data/modulesMaps'

function getMyWorksToDo(companyId, query) {
  return dataTransferWrap(
    ModulesMap.DONE_WORKS_MY_WORKS_TO_DO,
    dtConfig[ModulesMap.DONE_WORKS_MY_WORKS_TO_DO].getMyWorksToDo,
    {
      urlParams: {
        companyId,
      },
      params: query,
    },
  )
}

export default {
  getMyWorksToDo,
}